<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { commonMixin } from '@/utils/mixin.js'

export default {
  mixins: [commonMixin],
  data () {
    return {
      locale: zhCN
    }
  },
  mounted() {
    // this.changeFavicon()
  },
  watch: {
    // 监听platformConfig的变化
    '$store.state.user.platformConfig': {
      handler(newVal) {
        // 当platformConfig有值时，设置shouldChangeFavicon为true
        if (newVal && newVal.length > 0) {
          // this.shouldChangeFavicon = true;
          this.changeFavicon();
        }
      },
      deep: true
    }
  },
  methods:{
    changeFavicon() {
      let link = document.querySelector('link[rel*="icon"]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'shortcut icon';
      }
      const platformConfig = this.$store.state.user.platformConfig;
      const homeLogoIconSmall = platformConfig.find(
          item => item.code === 'HOME_LOGO_ICON_SMALL'
      )
      const fileId = homeLogoIconSmall ? homeLogoIconSmall.value : '';
      link.href=this.filePreview(fileId)
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
	height: 100%;
	width: 100%;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
